import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

type ContentPaneOverlayContextValue = {
  overlay: ReactNode;
  setOverlay: (overlay: ReactNode) => void;
};

const ContentPaneOverlayContext = createContext<ContentPaneOverlayContextValue | null>(null);

export function ContentPaneOverlayProvider({ children }: { children: ReactNode }) {
  const [overlay, setOverlay] = useState<ReactNode>(null);

  return (
    <ContentPaneOverlayContext.Provider value={{ overlay, setOverlay }}>
      {children}
    </ContentPaneOverlayContext.Provider>
  );
}

export function ContentPaneOverlaySlot() {
  const context = useContext(ContentPaneOverlayContext);
  if (!context) return null;
  return <>{context.overlay}</>;
}

export function ContentPaneOverlay({ children }: { children: ReactNode }) {
  const context = useContext(ContentPaneOverlayContext);

  useEffect(() => {
    if (!context) return;
    context.setOverlay(children);
    return () => context.setOverlay(null);
  }, [children, context]);

  return null;
}
